import BrowserDetector from '@/scripts/helpers/browser-detector';
import loginController from '@/scripts/libs/login/controller';

/**
 * @returns boolean indicate whether the service is required or not.
 */
export const checkServiceRequirement = async(): Promise<boolean> => {
  // Skip service for mobile user
  if (BrowserDetector.md().phone()) {
    return false;
  }

  // Skip service if user is logged in
  if (await loginController.getUser()) {
    return false;
  };

  return true;
};
